import { render } from "./Workflow.vue?vue&type=template&id=3364df70&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"

import "./Workflow.vue?vue&type=style&index=0&id=3364df70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3364df70"]])

export default __exports__